/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Bank: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M23 21H22V13H20V21H16V13H14V21H10V13H8V21H4V13H2V21H1C0.448 21 0 21.447 0 22C0 22.553 0.448 23 1 23H23C23.552 23 24 22.553 24 22C24 21.447 23.552 21 23 21Z'
      fill='currentColor'
    />
    <path
      d='M23.479 6.12199L12.479 0.121988C12.18 -0.0400117 11.82 -0.0400117 11.521 0.121988L0.521 6.12199C0.2 6.29699 0 6.63399 0 6.99999V9.99999C0 10.553 0.448 11 1 11H23C23.552 11 24 10.553 24 9.99999V6.99999C24 6.63399 23.8 6.29699 23.479 6.12199ZM12 7.99999C10.895 7.99999 10 7.10499 10 5.99999C10 4.89499 10.895 3.99999 12 3.99999C13.105 3.99999 14 4.89499 14 5.99999C14 7.10499 13.105 7.99999 12 7.99999Z'
      fill='currentColor'
    />
  </React.Fragment>
)
